<template>
  <div class="CompleteIO">
    <section-personel-search-panel :accessTo="54" @search="search"/>
    <box class="mt-2" :title="$t('IntervalIOReportList')">
      <div v-if="list.length > 0">
        <IntervalIOReportListWeb :list="list" class="hidden-sm-and-down" />
        <IntervalIOReportListMob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import IntervalIOReportListMob from '../../components/io/IntervalIOReport/IntervalIOReportListMob.vue';
import IntervalIOReportListWeb from '../../components/io/IntervalIOReport/IntervalIOReportListWeb.vue';
import SectionPersonelSearchPanel from "../../components/personelOperationReport/SectionPersonelSearchPanel.vue";
export default {
  components: { SectionPersonelSearchPanel, IntervalIOReportListWeb, IntervalIOReportListMob },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    search(searchParams) {
      const params = searchParams

      this.$store.dispatch("GetPersonMergeIo", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          this.list = result.data.Table;
        }
      });
    },
  },
};
</script>

<style>
</style>